// src/pages/Cuartos.tsx
import EliminatoriaCompartida from "./EliminatoriaCompartida";

const Cuartos = () => (
  <EliminatoriaCompartida
    fase="cuartos"
    titulo="Predicciones Cuartos de Final"
    endpoint="/cuartos/partidos"
    fechaPrimerPartido="2026-07-10T15:00:00"
  />
);

export default Cuartos;
